app.controller('CIFProfile-CTRL', ['$scope', '$http', '$window', '$q', 'appFactory',
    function ($scope, $http, $window, $q, appFactory) {

    $scope.CIFInvestor = {}
    $scope.chkquestionfatca = 2;

    $scope.back = function () {
        $window.location.href = "#/dashboard";
    }
    var allPromise = $q.all([
        $scope.retrieveSessions()
    ]);


    allPromise.then(function () {

        appFactory.getData(`/service/client.svc/getCIFDetail`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.QuestionRDN = "BANK CENTRAL ASIA";
                    $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                    $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                    $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                    $scope.URLFolderKYC = data.data.d.URLFolderKYC;

                    console.log($scope.CIFInvestor.NPWPFile)

                    $scope.imgItem = [];
                    if ($scope.CIFInvestor.KTPFile !== '')
                        $scope.imgItem.push({ editing: false, url: '/FileKYC/' + $scope.CIFInvestor.KTPFile + "?timestamp=" + Date.now(), type: 'KTP', label: 'KTP' });
                    
                    if ($scope.CIFInvestor.SelfieFile !== '')
                        $scope.imgItem.push({ editing: false, url: '/FileKYC/' + $scope.CIFInvestor.SelfieFile + "?timestamp=" + Date.now(), type: 'FotoDiri', label: 'Foto Diri bersama KTP' });

                    if ($scope.CIFInvestor.TandaTanganFile !== '')
                        $scope.imgItem.push({ editing: false, url: '/FileKYC/' + $scope.CIFInvestor.TandaTanganFile + "?timestamp=" + Date.now(), type: 'TandaTangan', label: 'Tanda Tangan Nasabah' });

                    if ($scope.CIFInvestor.NPWPFile !== '')
                        $scope.imgItem.push({ editing: false, url: '/FileKYC/' + $scope.CIFInvestor.NPWPFile + "?timestamp=" + Date.now(), type: 'NPWP', label: 'NPWP Nasabah' });

                    if ($scope.CIFInvestor.Sex) {
                        if ($scope.CIFInvestor.Sex == 'Male') {
                            $scope.imgMale = "../img/svg/report-male.svg";
                        }

                        if ($scope.CIFInvestor.Sex == "Female") {
                            $scope.imgMale = "../img/svg/report-animate.svg";
                        }
                    }

                    if ($scope.CIFInvestor.FATCA1 == 'Tidak' || $scope.CIFInvestor.FATCA2 == 'Tidak' || $scope.CIFInvestor.FATCA3 == 'Tidak') {
                        $scope.chkquestionfatca = 1;
                    }

                    if ($scope.CIFInvestor.IsFinished == 1) {
                        $scope.active = "active current";
                    }

                }
            }
        });

        $scope.navbarOptions = true;
    });
}]);